import React, { useState } from 'react';
import './ScheduleView.css';
import chevronDown from './assets/chevron-down.svg';

interface CorrectionSlideDownProps {
  correction: string;
}

export const CorrectionSlideDown: React.FC<CorrectionSlideDownProps> = ({ correction }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='correction-container'>
      <button className='correction-toggle' onClick={toggleOpen} aria-expanded={isOpen}>
        <span className='correction-label'>Oikaisu</span>
        <img
          alt={isOpen ? 'Sulje' : 'Avaa'}
          src={chevronDown}
          className='correction-chevron'
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </button>
      {isOpen && <div className='correction-content'>{correction}</div>}
    </div>
  );
};
